import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";
import { useCart } from "../context/CartContext";

const HIDDEN_ON = ["/cart", "/payment", "/login", "/register", "/admin"];

export const FloatingBasket = () => {
  const { count, subtotal } = useCart();
  const { pathname } = useLocation();
  const [bump, setBump] = useState(false);
  const prev = useRef(count);

  useEffect(() => {
    if (count > prev.current) {
      setBump(true);
      const t = setTimeout(() => setBump(false), 450);
      prev.current = count;
      return () => { clearTimeout(t); };
    }
    prev.current = count;
  }, [count]);

  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <Link
      to="/cart"
      aria-label={`Open basket, ${count} item${count === 1 ? "" : "s"}`}
      className={`fixed bottom-6 left-6 z-40 flex items-center gap-2 rounded-full bg-white text-slate-900 border border-slate-200 shadow-xl shadow-slate-900/10 pl-3 pr-4 py-2.5 hover:-translate-y-0.5 hover:shadow-2xl active:scale-95 transition-[transform,box-shadow] duration-200 ${bump ? "scale-110" : ""}`}
      data-testid="floating-basket-button"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-indigo-600 text-white">
        <ShoppingBasket className="w-5 h-5" />
        {count > 0 && (
          <span
            className="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 rounded-full text-[11px] font-bold flex items-center justify-center text-white ring-2 ring-white"
            style={{ background: "#FF6B6B" }}
            data-testid="floating-basket-count"
          >
            {count}
          </span>
        )}
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-xs font-semibold text-slate-500">Basket</span>
        <span className="text-sm font-bold" data-testid="floating-basket-total">${subtotal.toFixed(2)}</span>
      </span>
    </Link>
  );
};
